// src/divider/src/divider.tsx
import { jsx } from "react/jsx-runtime";
var Divider = () => /* @__PURE__ */ jsx("hr", {});

export {
  Divider
};
